import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { Action, Store } from '@ngrx/store';
import * as actions from '../actions/search';
import * as routerActions from '../../core/actions/router';
import { SiteService } from '../services/site';
import { of } from 'rxjs/observable/of';
import { DownloadedDocument } from '../../document/models/downloaded-document';
import {saveAs} from 'file-saver';
import { DocumentService } from '../services/document';
import * as fromRoot from '../reducers';
import * as siteActions from '../actions/site';

@Injectable()
export class SearchEffects {

  @Effect()
  searchDocuments$: Observable<Action> = this.actions$
    .ofType(actions.SEARCH_DOCUMENTS)
    .map((action: actions.SearchDocumentsAction) => action.payload)
    .switchMap(pm => {
      const nextLookup$ = this.actions$.ofType(actions.SEARCH_DOCUMENTS).skip(1);
      const errorMessage = 'Error searching.';
      return this.siteService.search(pm)
        .takeUntil(nextLookup$)
        .map(p => new actions.SearchDocumentsCompleteAction(p))
        .catch(e => of({type: 'ERROR', payload: { error: e, message: errorMessage}}));
    });

    @Effect()
    loadDocumentDetail$: Observable<Action> = this.actions$
      .ofType(actions.LOAD_DOCUMENT_DETAIL)
      .map((action: actions.LoadDocumentDetailAction) => action.payload)
      .switchMap(pm => {
        const nextLookup$ = this.actions$.ofType(actions.LOAD_DOCUMENT_DETAIL).skip(1);
        const errorMessage = 'Error loading document detail.';
        return this.documentService.details(pm)
          .takeUntil(nextLookup$)
          .map(p => new actions.LoadDocumentDetailCompleteAction(p))
          .catch(e => of({type: 'ERROR', payload: { error: e, message: errorMessage}}));
      });


    @Effect()
    upsertMetaData$: Observable<Action> = this.actions$
      .ofType(actions.UPSERT_DOCUMENT_METADATA)
      .map((action: actions.UpsertDocumentMetadataAction) => action.payload)
      .switchMap(pm => {
        const nextLookup$ = this.actions$.ofType(actions.UPSERT_DOCUMENT_METADATA).skip(1);
        const errorMessage = 'Error updating document detail.';
        return this.documentService.upsert(pm)
          .takeUntil(nextLookup$)
          .map(p => new actions.UpsertDocumentMetadataCompleteAction(p))
          .catch(e => of({type: 'ERROR', payload: { error: e, message: errorMessage}}));
      });

    @Effect()
    searchDocumentsComplete$: Observable<Action> = this.actions$
      .ofType(actions.SEARCH_DOCUMENTS_COMPLETE)
      .map(pm => new routerActions.Go({ path: ['/searchresults']}));

    @Effect()
    upsertDocumentComplete$: Observable<Action> = this.actions$
      .ofType(actions.UPSERT_DOCUMENT_METADATA_COMPLETE)
      .withLatestFrom(this.store)
      .mergeMap(pm => [new routerActions.Go({ path: ['/searchresults']}),
      new actions.SearchDocumentsAction(pm[1].irar.search.criteria),
      new siteActions.LoadAuthorsAction()]);

    @Effect()
  downloadFile$: Observable<Action> = this.actions$
    .ofType(actions.DOWNLOAD_FILE)
    .map((a: actions.DownloadFileAction) => a.payload)
    .switchMap(d => {
      const errorMessage = 'Error downloading file';
      return this.siteService.download(d.id)
        .map(file => new actions.DownloadFileCompleteAction(new DownloadedDocument(file, d.value)))
        .catch(e => of({type: 'ERROR', payload: errorMessage + '  ' + e.message}));
    });

  @Effect()
  downloadFileComplete$: Observable<Action> = this.actions$
    .ofType(actions.DOWNLOAD_FILE_COMPLETE)
    .map((a: actions.DownloadFileCompleteAction) => a.payload)
    .switchMap(doc => {
        this.saveFile(doc.file, doc.filename);
        return of({type: 'NO_ACTION'});
    });

    @Effect()
  loadGlennDale$: Observable<Action> = this.actions$
    .ofType(actions.LOAD_GLENN_DALE_DOCUMENTS)
    .switchMap(d => {
      const nextLookup$ = this.actions$.ofType(actions.LOAD_GLENN_DALE_DOCUMENTS).skip(1);
      const errorMessage = 'Error loading Glenn Dale files';
      return this.documentService.glennDale()
        .takeUntil(nextLookup$)
        .map(p => new actions.LoadGlennDaleDocumentsCompleteAction(p))
        .catch(e => of({type: 'ERROR', payload: errorMessage + '  ' + e.message}));
    });

  private saveFile(data: any, filename: string) {
    const blob = new Blob(data, { type: 'application/octet-stream'});
    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
      window.navigator.msSaveBlob(blob, filename);
    } else {
      saveAs(blob, filename);
    }
  }

    constructor(private actions$: Actions,
                private siteService: SiteService,
                private store: Store<fromRoot.State>,
                private documentService: DocumentService) {}
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/effects/search.ts